<script setup lang="ts">
/**
 * FW-145 tur 2 — design/current/Auth v2.dc.html satir 45: gorsel URL'i
 * yokken (bu depoda her zaman — gercek bir CMS gorsel yukleme ucu yok)
 * placeholder kutusu uc parcalidir: ikon (▣) + alt metni + mono boyut
 * notu ({{b.spec}}). Onceden yalniz alt metni render ediliyordu; ikon ve
 * spec satiri HIC YOKTU (koordinator FW-145 tur 2 bulgusu).
 */
defineProps<{
  readonly alt: string
  readonly spec: string | null
}>()
</script>

<template>
  <div
    class="fw-welcome-image"
    role="img"
    :aria-label="alt"
  >
    <span
      class="fw-welcome-image__icon"
      aria-hidden="true"
    >▣</span>
    <span>{{ alt }}</span>
    <span
      v-if="spec"
      class="fw-welcome-image__spec"
    >{{ spec }}</span>
  </div>
</template>

<style scoped>
.fw-welcome-image {
  width: 100%;
  max-width: 520px;
  aspect-ratio: 5 / 3;
  max-height: 30vh;
  border-radius: 12px;
  border: 1px dashed rgba(255, 255, 255, 0.28);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
  flex: none;
}

.fw-welcome-image__icon {
  font-size: 18px;
}

.fw-welcome-image__spec {
  font-family: var(--fw-font-mono);
  font-size: 10px;
}
</style>
